/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { AudienceType, QuestionType } from '../../../algorithm/types';
import { audienceToUrlParam } from '../../../utils';
import { SEARCH_PARAM } from '../../useHooks';

export function questionTypeAsString(question: QuestionType) {
  switch (question.type) {
    case 'exclusive':
      if (question.options.length > 1) {
        return 'Single Selection';
      } else {
        return undefined;
      }
    case 'multiple_choice':
      if (question.options.length > 1) {
        return 'Multiple Selection';
      } else {
        return undefined;
      }
    default:
      return undefined;
  }
}
/* When a highlighted keyword occurs more than twice in a three-line summary,
   only retain the first two occurrences. If there are phrases like "Chronic joint pain"
   if it has multiple occurrences. If there's only a single occurrence, it should
   be shown as it is. */

export function fixUpSummary(summary: string) {
  const occurrence = new Map<string, number>();
  return summary.replace(/<b>(.*?)<\/b>/g, (match, content) => {
    const lowerContent = content.toLowerCase();
    const currentOccurrence = (occurrence.get(lowerContent) || 0) + 1;
    occurrence.set(lowerContent, currentOccurrence);
    return currentOccurrence <= 2 ? match : content;
  });
}

export function slugToUrl(
  slug: string | undefined,
  title: string,
  searchTerm: string,
  documentVersionId: string | undefined,
  publishedOnly: boolean | undefined,
  audience: AudienceType
) {
  const encodedTitle = encodeURI(title);
  if (slug) {
    return `/chat?${SEARCH_PARAM.SLUG}=${slug}&${audienceToUrlParam(audience, publishedOnly, true)}&${
      SEARCH_PARAM.TITLE
    }=${encodedTitle}`;
  }
  return title.toLowerCase() === searchTerm.toLowerCase() && documentVersionId
    ? `/chat?${SEARCH_PARAM.DOCUMENT_VERSION}=${documentVersionId}&${audienceToUrlParam(
        audience,
        publishedOnly,
        true
      )}&${SEARCH_PARAM.TITLE}=${encodedTitle}`
    : `#${encodedTitle}`;
}

export const OPEN_FDA_URL = 'https://open.fda.gov/terms';
